import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import img1 from "../../img/dots-1.png"
import { faFacebookF, faTwitter, faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons'
import { faEnvelopeOpenText, faSearchDollar } from '@fortawesome/free-solid-svg-icons'

import { Col, Container, Row } from 'react-bootstrap';
// envelope-open-text
// const Github = <FontAwesomeIcon icon={faGithub} />
// const EnvelopeOpenText = <FontAwesomeIcon icon={faEnvelope} />
const Facebook = <FontAwesomeIcon icon={faFacebookF} />
const Twitter = <FontAwesomeIcon icon={faTwitter} />
const LinkedinIn = <FontAwesomeIcon icon={faLinkedinIn} />
const Github = <FontAwesomeIcon icon={faGithub} />
const EnvelopeOpenText = <FontAwesomeIcon icon={faEnvelopeOpenText} />
const SearchDollar = <FontAwesomeIcon icon={faSearchDollar} />

const Social = () => {
    const arraySocial = [
        {
            link: "https://mail.google.com/mail/u/0/#inbox",
            logo: EnvelopeOpenText,
            text: 'pustfarid333@gmail.com',
            name: "Email"
        },
        {
            link: "https://www.facebook.com/mdfarid.hossain.9003/",
            logo: Facebook,
            text: 'Personal Social Profile',
            name: "Facebook"
        },
        {
            link: "https://github.com/developerfarid",
            logo: Github,
            text: 'Professional Github Profile',
            name: "Github"
        },
        {
            link: "https://www.linkedin.com/in/md-farid-hossain-448352206/",
            logo: LinkedinIn,
            text: 'Personal Linkedin Profile',
            name: "Linkedin"
        },



        {
            link: "https://twitter.com/farid_jibon",
            logo: Twitter,
            text: 'Follow Me in Twitter',
            name: "Twitter"
        },
        {
            link: "https://www.upwork.com/freelancers/~018092931a24b99888",
            logo: SearchDollar,
            text: 'Market Place  Profile',
            name: "Upwork"
        },
    ]
    return (
        <Container className='pb-5'>
            <Row>
                <Col>
                    <div className="project-title">
                        <p>SOCIAL MEDIA</p>
                        <h3>Let’s Be Friends</h3>
                        <img className='img-fluid' src={img1} alt="" />
                    </div>
                </Col>
            </Row>
            <Row lg={3} md={2} xs={1} className='gy-4'>
                {
                    arraySocial.map(item => (
                        <Col>
                            <a className='text-decoration-none' href={item.link} target="_blank" rel="noreferrer">
                                <div className="social d-flex justify-content-between align-items-center p-3">
                                    <div className="social-text">
                                        <h3>{item.name}</h3>
                                        <p>{item.text}</p>
                                    </div>
                                    <div className="icon-social fs-2">
                                        {item.logo}
                                    </div>
                                </div>
                            </a>
                        </Col>
                    ))
                }
            </Row>
        </Container>
    );
};

export default Social;